import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const ImpressumPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#121212] text-gray-200">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Button
          data-testid="impressum-back-btn"
          onClick={() => navigate(-1)}
          variant="ghost"
          className="text-gray-400 hover:text-white mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" /> Zurück
        </Button>

        <h1 data-testid="impressum-title" className="text-3xl sm:text-4xl font-bold text-white mb-8">
          Impressum
        </h1>

        <div className="space-y-8 text-sm leading-relaxed">
          {/* §5 TMG */}
          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">Angaben gemäß § 5 TMG</h2>
            <p>
              Allgaeu Travel & Transport E-GmbH<br />
              Stanko-Valchanov-Str. 5<br />
              9006 Varna
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">Kontakt</h2>
            <p>
              Support: Über den KI-gestützten Support in der App erreichbar (24/7)
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">Umsatzsteuer-ID</h2>
            <p>
              Steuer-Nr.: 207984162<br />
              Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
              BG207984162
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>
              Allgaeu Travel & Transport E-GmbH<br />
              Stanko-Valchanov-Str. 5<br />
              9006 Varna
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">EU-Streitschlichtung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#00BFA6] underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
              <br />
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">Haftung für Inhalte</h2>
            <p className="text-gray-300">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen
              zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="text-gray-300 mt-2">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
              Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
              Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
              Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">Haftung für Links</h2>
            <p className="text-gray-300">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
              verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#00BFA6] mb-3">Urheberrecht</h2>
            <p className="text-gray-300">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </section>

          <section className="bg-[#1E1E1E] border border-white/10 rounded-xl p-6">
            <h2 className="text-lg font-semibold text-yellow-400 mb-3">Hinweis zu Sportwetten</h2>
            <p className="text-gray-300">
              OddsCortex ist eine reine Analyse-Software und keine Wettberatung im rechtlichen Sinne.
              Unsere KI-generierten Tipps stellen keine Empfehlung zum Platzieren von Wetten dar.
              Wetten birgt Risiken und kann süchtig machen. Hilfe unter{' '}
              <a href="https://www.bzga.de" className="text-[#00BFA6] underline" target="_blank" rel="noopener noreferrer">
                www.bzga.de
              </a>
              . Nur für Personen ab 18 Jahren.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-gray-500 text-xs">
          Stand: März 2026
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;
